<template>
    <div class="content">
        <div>            
            <md-table v-model="users" :table-header-color="tableHeaderColor">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Email">{{ item.email }}</md-table-cell>
                <md-table-cell md-label="Last login">{{ item.last_login }}</md-table-cell>
                <md-table-cell md-label="Last IP">{{ item.last_ip }}</md-table-cell>
                <md-table-cell md-label="is_active">{{ item.is_active }}</md-table-cell>
            </md-table-row>
            </md-table>
        </div>
    </div>
</template>
<script>
import {API} from '../services'

export default {
  name: "admin",
  props: {
    tableHeaderColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      selected: [],
      users: [        
      ]
    };
  },
  created: function () {
      API.getUsers().then(
                  response => {                      
                    this.users = response.data
                  },
              );
  }

};
</script>
